import React, { Component, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import GridItem from 'components/Grid/GridItem.js';
import GridContainer from 'components/Grid/GridContainer.js';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import Button from 'components/CustomButtons/Button.js';
import DateFnsUtils from '@date-io/date-fns';

const useStyles = (theme) => ({
  root: {
    '& .MuiFormControl-root': {
      margin: theme.spacing(2),
      width: '105% !important',
      marginLeft: '1px',
    },
  },
  rootCircular: {
    flexGrow: 1,
    backgroundColor: '#f1f1f2',
  },
  green: {
    '& label.Mui-focused': {
      color: 'green',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'green',
    },
  },
  buttonAlign: {
    float: 'right',
  },
});

// preparando refatoração para componente funcional
// const [dateFrom, setDateFrom] = useState(null);
// const handleChangeDateFrom = (dateFrom) => setDateFrom(dateFrom);
// const [dateTo, setDateTo] = useState(null);
// const handleChangeDateTo = (dateTo) => setDateTo(dateTo);
// const [circular, setCircular] = useState(false);
// const handleCircular = () => setCircular(!circular);

class SearchRelatoriosOperacoes extends Component {
  state = {
    code: '',
    usuario: '',
    porta: '',
    encomenda: '',
    dateFrom: null,
    dateTo: null,
    circular: false,
    finalValue: '',
    finalField: '',
    setEncomenda: false,
    group: null,
    lockerS: null,
    origen: [
      {
        value: "manage",
        label: "Sistema de Gestão"
      },
      {
        value: "locker",
        label: "Locker"
      },
      {
        value: null,
        label: "Ambos"
      },
    ],
    origenSelect: null
  };

  handleClearInput = () => {
    this.setState({
      code: '',
      usuario: '',
      porta: '',
      encomenda: '',
      dateFrom: null,
      dateTo: null,
      finalValue: '',
      finalField: '',
      setEncomenda: false,
    });
  };

  handleChangeLocker = (locker) => {
    this.setState({ lockerS: locker.target.value });
  };

  handleChangeGroup = (group) => {
    this.setState({ group: group.target.value });
  }

  handleChangeOrigen = (origenSelect) => {
    this.setState({ origenSelect: origenSelect.target.value });
  }

  handleChange = (event) => {

    //console.log(`event:: ${JSON.stringify(event)}`);
    const e = event.target.id ? event.target.id : event.target.name;
    const { value } = event.target;

    switch (e) {
      case 'code':
        this.setState({ code: value, finalValue: value, finalField: e });
        break;
      case 'usuario':
        this.setState({ usuario: value, finalValue: value, finalField: e });
        break;
      case 'parametro1':
        this.setState({ porta: Number(value), finalValue: Number(value), finalField: e });
        break;
      case 'encomenda':
        this.setState({ encomenda: value, finalValue: value, finalField: e, setEncomenda: true });
        break;
      case 'lockers':
        this.setState({ finalValue: value, finalField: e });
        break;
    }

    console.log('dentro do handle CHANGE, campo e valor:', e, value);
  };

  handleChangeDateFrom = (dateFrom) => {
    this.setState({ dateFrom, finalField: 'dateFrom' });
  };

  handleChangeDateTo = (dateTo) => {
    this.setState({ dateTo, finalField: 'dateTo' });
  };

  handleFilterTable = () => {
    const { finalField, finalValue, dateFrom, dateTo, code, usuario, group, lockerS, origenSelect } = this.state;
    this.props.filterTable(finalField, finalValue, dateFrom, dateTo, code, usuario, group, lockerS, origenSelect);
    this.handleClearInput();
  };

  render() {
    const { show, classes, operations, groups, lockers, groupedLockers } = this.props;
    let { dateFrom, dateTo, setEncomenda, code, group, lockerS, origen, origenSelect } = this.state;

    // console.log('vindo do pai as operações', operations);

    if (!show) return null;

    return (
      <div className={classes.green}>
        <form className={classes.root} noValidate autoComplete="off">
          <h5>PESQUISAR OPERAÇÕES</h5>

          <GridContainer>
            <GridItem xs={12} sm={6} md={4}>
              <TextField
                className={classes.green}
                select
                disabled={setEncomenda}
                label="Operação"
                name="code"
                id="code"
                value={code}
                onChange={this.handleChange}
              >
                {operations.map(({ codigo, operacao }) => (
                  <MenuItem key={codigo} value={codigo}>
                    {codigo + ' - ' + operacao}
                  </MenuItem>
                ))}
              </TextField>
            </GridItem>

            <GridItem xs={12} sm={6} md={4}>
              <TextField
                className={classes.green}
                select
                disabled={setEncomenda}
                label="Origem"
                name="origen"
                id="origen"
                value={origenSelect}
                onChange={this.handleChangeOrigen}
              >
                {origen.map(option => (
                  <MenuItem key={option.value} value={option}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </GridItem>

            <GridItem xs={12} sm={6} md={4}>
              <FormControl className={classes.green}>
                <InputLabel htmlFor="usuario">Usuário</InputLabel>
                <Input
                  onChange={this.handleChange}
                  name="usuario"
                  id="usuario"
                  disabled={setEncomenda}
                />
              </FormControl>
            </GridItem>

            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <GridItem xs={12} sm={6} md={4}>
                <KeyboardDatePicker
                  disabled={setEncomenda}
                  disableToolbar
                  variant="inline"
                  format="dd/MM/yyyy"
                  margin="normal"
                  id="from"
                  label="Data inicial:"
                  value={dateFrom}
                  onChange={this.handleChangeDateFrom}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
              </GridItem>

              <GridItem xs={12} sm={6} md={4}>
                <KeyboardDatePicker
                  disabled={setEncomenda}
                  disableToolbar
                  variant="inline"
                  format="dd/MM/yyyy"
                  margin="normal"
                  id="to"
                  label="Data final:"
                  value={dateTo}
                  onChange={this.handleChangeDateTo}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
              </GridItem>
            </MuiPickersUtilsProvider>

            <GridItem xs={12} sm={6} md={4}>
              <FormControl className={classes.green}>
                <InputLabel htmlFor="encomenda">Encomenda</InputLabel>
                <Input onChange={this.handleChange} name="encomenda" id="encomenda" />
              </FormControl>
            </GridItem>

            <GridItem xs={12} sm={6} md={4}>
              <TextField
                className={classes.green}
                id="locker"
                name="locker"
                select
                label="Locker"
                value={lockerS}
                onChange={this.handleChangeLocker}
              >
                {lockers.map((option) => (
                  <MenuItem key={option.value} value={option}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </GridItem>
            <GridItem xs={12} sm={6} md={4}>
              <TextField
                className={classes.green}
                id="outlined-size-input"
                select
                label="Grupo"
                value={group}
                onChange={this.handleChangeGroup}
              >
                {groups.map((option) => (
                  <Tooltip title={groupedLockers[option.value]} key={option.value} value={option}>
                    <MenuItem className='item-group' key={option.value} value={option}>
                      {option.label}
                    </MenuItem>
                  </Tooltip>
                ))}
              </TextField>
            </GridItem>
          </GridContainer>
          <Button onClick={this.handleFilterTable} color="primary" autoFocus>
            Pesquisar
          </Button>
        </form>
      </div>
    );
  }
}

export default withStyles(useStyles)(SearchRelatoriosOperacoes);
